import { IContact } from "@osapp/model";
import { IPatient } from "../../../../modules/patients/model/IPatient";

export class PatientHelper {
  public static getPatientFirstName(contact: IContact): string | undefined {
    const value = contact?.['firstName'];
    return value ? value.substring(0, 64) : undefined;
  }

	public static getFullNamePatient(patient: IPatient): string {
			const maxlength = 64;
			if(!patient) return "";
			if (patient.usualLastName && patient.lastName.toUpperCase() !== patient.usualLastName.toUpperCase()) {
				return `${patient.usualLastName.substring(0,maxlength)} (${patient.lastName.substring(0,maxlength)})`;
			} else {
				return patient.lastName;
			}
		}
}

